import $ from 'jquery';

function handleVideoClick(e) {
	const imageMask = e.target;
	const $videoPlayer = $(imageMask).closest('.em-video-embed__player');
	if ($videoPlayer.hasClass('em-video-embed__player--active')) {
		$videoPlayer.find('video').get(0).pause();
	} else {
		$videoPlayer.find('video').get(0).play();
	}
	$videoPlayer.toggleClass('em-video-embed__player--active');
}

function handleVideoEmbed() {
	const videos = document.querySelectorAll('.em-video-embed__player');
	videos.forEach((item) => {
		item.addEventListener('click', handleVideoClick);
	});
}

window.addEventListener('load', handleVideoEmbed);
